import { baseApi, extractData } from "../api/axiosConfig";

export const getAllContractSectionFilters = () =>
    baseApi
        .get("/contractSectionFilter")
        .then(extractData);

export const getContractCSF = contractId =>
    baseApi
        .get("/contractSectionFilter/contractCSF", {
            params: {
                contractId
            }
        })
        .then(extractData);

export const getContractSectionCSF = contractSectionId =>
    baseApi
        .get("/contractSectionFilter/csf_native", {
            params: {
                contract_section_id: contractSectionId
            }
        })
        .then(extractData);

export const addContractSectionFilter = data =>
    baseApi
        .post("/contractSectionFilter", data)
        .then(extractData);

export const editContractSectionFilter = (contractSectionFilterId, data) =>
    baseApi
        .put(`/contractSectionFilter/${contractSectionFilterId}`, data)
        .then(extractData);

export const deleteContractSectionFilter = contractSectionFilterId =>
    baseApi
        .delete(`/contractSectionFilter/${contractSectionFilterId}`)
        .then(extractData);

export const updateSectionFilterHierarchy = id =>
    baseApi
        .get("/contractSectionFilter/hierarchy", {
            params: {
                cs_id: Number(id)
            }
        })
        .then(extractData);

export const deleteCSF = (contractSectionId, csfId, csfHierarchy) =>
    baseApi
        .get("/contractSectionFilter/deleteCSF", {
            params: {
                my_cs_id: contractSectionId,
                my_csf_id: csfId,
                my_csf_hierarchy: csfHierarchy
            }
        })
        .then(extractData);

export const advanceByFilter = myCdpId =>
    baseApi
        .get("/contractSectionFilter/advanceByFilter", {
            params: {
                my_cdp_id: myCdpId
            }
        })
        .then(extractData);

// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// export const getAllContractSectionFilters = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSectionFilter`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getContractCSF = (contractId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSectionFilter/contractCSF`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contractId: contractId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// // export const getContractSectionCSF = (contractSectionId) =>
// //     axios.get(`${BASE_URL}/api/contramatic/contractSectionFilter/contractSectionCSF`,
// //         {
// //             params: {contractSectionId: contractSectionId}
// //         })
// export const getContractSectionCSF = (contractSectionId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSectionFilter/csf_native`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contract_section_id: contractSectionId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export   const addContractSectionFilter = abcd =>
//     axios.post(`${BASE_URL}/api/contramatic/contractSectionFilter`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         // {params: {
//         //         accessType: abcd.accessType,
//         //         filteringMethod: abcd.filteringMethod,
//         //         contractSection:{id: abcd.contractSection.id},
//         //     parentFilter:{id: abcd.parentFilter.id},
//         //         dataPoint:{id: abcd.dataPoint.id}
//         //     }}
//         // )
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const editContractSectionFilter = (selectorContractSectionFilterId, data) =>
//     axios.put(`${BASE_URL}/api/contramatic/contractSectionFilter/${selectorContractSectionFilterId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteContractSectionFilter = selectorContractSectionFilterId =>
//     axios.delete(`${BASE_URL}/api/contramatic/contractSectionFilter/${selectorContractSectionFilterId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const updateSectionFilterHierarchy = (id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSectionFilter/hierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {cs_id: Number(id)}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const deleteCSF = ( selectorContractSectionId, selectorCsfId,selectorCsfHierarchy) =>
// // export const updateCDPV = (selectorCdpId, selectorDataType, data) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSectionFilter/deleteCSF`
//         ,
//         {
//             // params: {my_cdp_id: data.cdpId
//             //     ,
//             //     my_data_type: data.dataType,
//             //     my_value: data.value.toString()
//             // }
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cs_id: selectorContractSectionId,
//                 my_csf_id: selectorCsfId,
//                 my_csf_hierarchy: selectorCsfHierarchy
//                 // my_value: data.value2.toString()
//             }
//         }
//     )
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const advanceByFilter = (myCdpId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractSectionFilter/advanceByFilter`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: myCdpId}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
